import { AcessoCbo } from 'graphql/types.generated'
import { Permission } from 'types/Permissions'

export const isPermission = (permission): permission is Permission => permission.uri

export const isCboPermission = (permission): permission is AcessoCbo[] => !!AcessoCbo[permission[0]]
